import { render, staticRenderFns } from "./MainSocialLinks.vue?vue&type=template&id=ac0b78f4&scoped=true&"
import script from "./MainSocialLinks.vue?vue&type=script&lang=js&"
export * from "./MainSocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./MainSocialLinks.vue?vue&type=style&index=0&id=ac0b78f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0b78f4",
  null
  
)

export default component.exports